<template>
    <div v-if="props.params?.data.active === true && !systemAccount" class="flex items-center justify-center h-full">
        <button class="i-ph-pencil text-primary" data-cy="edit-button" @click="showEditor"/>
    </div>
</template>
<script setup lang="ts">

import {computed} from 'vue'
import {BookkeepingAccount} from '@/bookkeeping-account/BookkeepingAccount'

const props = defineProps({
    params: {
        required: true,
        type: Object as () => {
            context: {
                showEditor: Function
            }
            data: BookkeepingAccount
        },
    }
})

const systemAccount = computed(() => {
    const account = props.params?.data.accountNo
    return account.startsWith('27') || account.startsWith('1500') || account.startsWith('2400')
})

const showEditor = () => {
    props.params.context.showEditor(props.params.data)
}

</script>

<style scoped>

</style>